import * as element from './element'
import http from '@/axios'
import {checkApi, hasApi, checkPage} from "@router/permission"

export default {
  install (Vue) {
    // 接口
    Vue.prototype.$Http = http;
    Object.assign(Vue.prototype, {
      ...element,
      checkApi,
      hasApi,
      checkPage,
      // 判断并返回数组
      getArray(list) {
        return Array.isArray(list) ? list.filter(item => item != null) : []
      },
      // 拷贝对象的有效值
      copyObjValue(obj, copyObj) {
        for (let attr in copyObj) {
          if (Object.prototype.hasOwnProperty.call(copyObj, attr)) {
            if (copyObj[attr] || copyObj[attr] === 0) {
              obj[attr] = copyObj[attr]
            }
          }
        }
      },
      getCurrentTime(type, time) {
        let now = new Date(this.getTimeStamp(time));
        let year = now.getFullYear(); //得到年份
        let month = now.getMonth(); //得到月份
        let date = now.getDate(); //得到日期
        let hours = now.getHours();//得到小时
        let minutes = now.getMinutes();//得到分钟
        let seconds = now.getSeconds();//得到秒
        month = month + 1;
        month = month.toString().padStart(2, "0");
        date = date.toString().padStart(2, "0");
        hours = hours.toString().padStart(2, "0");
        minutes = minutes.toString().padStart(2, "0");
        seconds = seconds.toString().padStart(2, "0");
        let res = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;
        type === "full" && (res = `${year}-${month}-${date} ${hours}:${minutes}`);
        type === "date" && (res = `${year}-${month}-${date}`);
        type === "time" && (res = `${hours}:${minutes}:${seconds}`);
        return res;
      },
      formatLocation(row) {
        if (row.location) {
          const {province = "", city = "", country = ""} = row.location
          if (province || city) {
            if (country === "中国") {
              if (province === city) return province;
              return `${province}${(province && city) ? "，" : ""}${city}`;
            } else {
              return country;
            }
          } else {
            return country || "-"
          }
        } else {
          return "-"
        }
      },
      getTimeStamp(time) {
        if (!time) return new Date().getTime();
        if (this.isIE() || this.isSafari()) {time.replace && (time = time.replace(/-/g, "/"))}
        return new Date(time).getTime();
      },
      isIE() {
        return window.ActiveXObject || 'ActiveXObject' in window;
      },
      isSafari() {
        return /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      },
      flattenTree(tree) {
        let result = [];
        function flatten(nodes) {
          nodes.forEach((node) => {
            result.push(node);
            if (node.children && node.children.length) {
              flatten(node.children);
            }
          });
        }
        flatten(tree);
        return result;
      },
      formatDuration(val) {
        if (val < 1000) {
          val = `${val}纳秒`
        } else if (val < 1000000) {
          val = `${(val / 1000).toFixed(2)}微秒`;
        } else if (val < 1000000000) {
          val = `${(val / 1000000).toFixed(2)}毫秒`;
        } else {
          val = this.timeStamp(val / 1000000000);
        }
        return val;
      },
      // 分钟转小时、天
      timeStamp(val) {
        let StatusMinute = val;
        if (StatusMinute < 0) {
          StatusMinute = 0 + "秒";
          return StatusMinute
        }
        let day = parseInt((StatusMinute / 60 / 60 / 24)+"");
        let hour = parseInt((StatusMinute / 60 / 60 % 24)+"");
        let min = parseInt((StatusMinute / 60 % 60)+"");
        let second = parseInt((StatusMinute % 60)+"");
        StatusMinute = "";
        if (day > 0) {
          StatusMinute = day + "天";
        }
        if (hour > 0) {
          StatusMinute += hour + "小时";
        }
        if (min > 0) {
          StatusMinute += min + "分钟";
        }
        StatusMinute += second + '秒';
        return StatusMinute;
      },
      convertYuan(val) {
        return (val / 100).toFixed(2);
      },
      convertFen(val) {
        return (parseFloat(val) * 100).toFixed();
      },
      //拼接URL
      getUrl(url, obj) {
        let newUrl = "";
        Object.keys(obj).forEach(key => newUrl += `&${key}=${encodeURIComponent(obj[key])}`);
        return url += (url.indexOf('?') < 0 ? '?' : '') + newUrl.slice(1);
      },
      // 到期判断
      isExpire(time) {
        if (window.ActiveXObject || 'ActiveXObject' in window) {time = time.replace("-", "/")}
        let end = new Date(time).getTime();
        let now = new Date().getTime();
        return now > end;
      },
      // 下载文件(兼容IE)
      downloadFile(fileName, blob, type = "") {
        if (window?.navigator?.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName + type);
        } else {
          let link = document.createElement('a');
          link.download = fileName;
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      },
      /*将base64转换为文件  兼容ie11的写法*/
      base64URLtoBlob(url, filename = 'file') {
        let arr = url.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);// 解码base64
        let len = bstr.length;
        let u8arr = new Uint8Array(len);
        let suffix = mime.split('/')[1];
        while (len--) {
          u8arr[len] = bstr.charCodeAt(len)
        }
        let blob = new Blob([u8arr], {type: mime});
        blob.lastModifiedDate = new Date();
        blob.name = `${filename}.${suffix}`;
        return blob;
      },
      //处理表格项数据
      showTableData(prop, row, formatArr) {
        let empty_val = "-";
        if (prop && row) {
          let val = row;
          let isValid =
            prop.split &&
            prop.split(".").every(attr => {
              val = val[attr];
              return val || val === 0 || val === false;
            });
          return isValid ? this.formatData(val, formatArr) : empty_val;
        } else {
          return empty_val;
        }
      },
      randomString(count) {
        count = count || 32;
        let t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678", a = t.length, n = "";
        for (let i = 0; i < count; i++) n += t.charAt(Math.floor(Math.random() * a));
        return n
      },
      copyText(text) {
        let createInput = document.createElement('input');
        createInput.value = text;
        document.body.appendChild(createInput);
        createInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        createInput.className = 'createInput';
        createInput.style.display = 'none';
        element.msgSuccess('复制成功，可以粘贴了！');
      },
      // 格式化数据
      formatData(val, formatArr) {
        if (Array.isArray(formatArr)) {
          let item = formatArr.find(item => val == item.id);
          let formatVal = item?.msg || val;
          let color = item?.color || "";
          let backgroundColor = item?.backgroundColor || "";
          if (color) return `<span class="${color}">${formatVal}</span>`;
          if (backgroundColor) return `<span style="display:inline-block;width:100%;color:${backgroundColor};background-color:${backgroundColor}">${formatVal}</span>`;
          return formatVal;
        } else {
          return val;
        }
      },
      // 打开新窗口等待样式(远程时调用)
      drawNewPage(newPage) {
        newPage.document.head.innerHTML =
          '<title>正在加载</title>' +
          '<style type="text/css">' +
          '#loading_mask{' +
          'position: fixed;' +
          'left: 0;' +
          'top: 0;' +
          'width: 100%;' +
          'height: 100%;' +
          'z-index: 99999;' +
          'background-color: #0000004d;' +
          '}' +
          '.loading_spinner {' +
          'top: 50%;' +
          'margin-top: -25px;' +
          'width: 100%;' +
          'text-align: center;' +
          'position: absolute;' +
          '}' +
          '.circular {' +
          'display: inline-block;' +
          'height: 50px;' +
          'width: 50px;' +
          'animation: loading-rotate 2s linear infinite;' +
          '}' +
          '.path {' +
          'animation: loading-dash 1.5s ease-in-out infinite;' +
          'stroke-dasharray: 90, 150;' +
          'stroke-dashoffset: 0;' +
          'stroke-width: 2;' +
          'stroke: #409eff;' +
          'stroke-linecap: round;' +
          '}' +
          '@keyframes loading-rotate {' +
          '100% {' +
          'transform: rotate(360deg);' +
          '}' +
          '}' +
          '@keyframes loading-dash {' +
          '0% {' +
          'stroke-dasharray: 1, 200;' +
          'stroke-dashoffset: 0;' +
          '}' +
          '50% {' +
          'stroke-dasharray: 90, 150;' +
          'stroke-dashoffset: -40px;' +
          '}' +
          '100% {' +
          'stroke-dasharray: 90, 150;' +
          'stroke-dashoffset: -120px;' +
          '}' +
          '}' +
          '</style></head><body>';
        newPage.document.body.innerHTML =
          '<div id="loading_mask">' +
          '<div class="loading_spinner">' +
          '<svg viewBox="25 25 50 50" class="circular">' +
          '<circle cx="50" cy="50" r="20" fill="none" class="path"></circle>' +
          '</svg>' +
          '</div>' +
          '</div>'
      }
    });
  }
}
